import { constants } from './constants'

export default {
  // Note: set the currentEnv to corresponding environment before deploying the code
  currentEnv: constants.Environment.PPE,

  baseURL: function () {
    var baseurl = ''
    switch (this.currentEnv) {
      case constants.Environment.PPE:
        baseurl = 'https://mdadminapi.azurewebsites.net'
        break
      case constants.Environment.INT:
        baseurl = 'https://stage-dmadminapi-ipl.azurewebsites.net'
        break
      case constants.Environment.LOCAL:
        baseurl = 'http://localhost:53428'
        break
      default:
        baseurl = 'https://dev-dmadminapi-ipl.azurewebsites.net'
        break
    }
    console.log('Build Version: ' + constants.Current_Build_Version)
    return baseurl
  },
  clientId: function () {
    var clientid = ''
    switch (this.currentEnv) {
      case constants.Environment.PPE:
        clientid = constants.Mentora_Prod_Auth0_Client_Id
        break
      case constants.Environment.INT:
        clientid = constants.Mentora_Stage_Auth0_Client_Id
        break
      case constants.Environment.DEV:
        clientid = constants.Mentora_Dev_Auth0_Client_Id
        break
      default:
        clientid = constants.Mentora_Prod_Auth0_Client_Id
        break
    }
    return clientid
  },
  realmOrConnection: function () {
    var realmorconnection = ''
    switch (this.currentEnv) {
      case constants.Environment.PPE:
        realmorconnection = constants.Mentora_Prod_Auth0_Realm_Or_Connection
        break
      case constants.Environment.INT:
        realmorconnection = constants.Mentora_Stage_Auth0_Realm_Or_Connection
        break
      case constants.Environment.DEV:
        realmorconnection = constants.Mentora_Dev_Auth0_Realm_Or_Connection
        break
      default:
        realmorconnection = constants.Mentora_Prod_Auth0_Realm_Or_Connection
        break
    }
    return realmorconnection
  },
  getMentoraWebPlatformURL: function () {
    var webUrl = ''
    switch (this.currentEnv) {
      case constants.Environment.PPE:
        webUrl = 'http://mentora.personalleadership.com'
        break
      case constants.Environment.INT:
        webUrl = 'https://mentora-web-staging.azurewebsites.net'
        break
      case constants.Environment.DEV:
        webUrl = 'https://mentora-web-dev.azurewebsites.net'
        break
      default:
        webUrl = constants.Mentora_Prod_Auth0_Realm_Or_Connection
        break
    }
    return webUrl
  }
}



// WEBPACK FOOTER //
// ./src/utils/server.js